<template>
  <v-main class="gradientBkg">
    <slot />
  </v-main>
</template>

<script>
export default {
  name: 'Login',
}
</script>

<style>
.gradientBkg {
  background: linear-gradient(to right top, #000, #000);
}
</style>
